<template>
    <footer class="foot">
      <div class="w1200 flexDiv">
        <div class="logo"><img src="../assets/img/LOGO-b.png" alt="logo"></div>
        <div class="address">
            <p>学院地址：四川省成都市金堂县大学城&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;招生代码：5706</p>
            <p>联系电话：028-6793-5809</p>
            <p class="beian">邮政编码：610400&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;备 案 号：<a href="https://beian.miit.gov.cn/" target="_blank" style="color: white; display: inline-block;">蜀ICP备10006587号-1</a></p>
        </div>
        <div class="ewmDiv">
          <ul class="flexDiv">
            <li v-for="(item,index) in codeData" :key='item.ID'>
              <em></em>
              <p><img :src="item.FileUrl" alt=""></p>
            </li>
          </ul>
        </div>
      </div>
    </footer>
</template>
<script>
export default{
    name:'foot',
    data(){
        return{
            codeData:[]
        }
    },
    created(){
        this.codeData = this.Base.GetFilesInfoByCid(7174,1,'',6,1);
        // console.log(this.codeData,'codeData')
    }
}
</script>
<style lang="less" scoped>
.foot{
  height: 178px;
  text-align: center;
  background-image: url(../assets/img/bgb.png);
  .w1200{
    padding-top: 38px;
    align-items: center;
  }
  .logo{
    margin: 20px 0;
    justify-content: center;
    width: 435px;
    height: 67px;
  }
  .address{
    p{
      width: 357px;
      font-size: 12px;
      font-weight: normal;
      color: #FFFFFF;
      line-height: 26px;
      letter-spacing: 1px;
      color: #ffffff;
      text-align: left;
    }
  }
  .ewmDiv{
    position: relative;
    ul{
      li{
        width: 45px;
        height: 45px;
        margin-left: 28px;
        cursor: pointer;
        position: relative;
        &:hover{
          &::before{
            content: '';
            width: 0;
             height: 0;
             border-width: 10px;
             border-style: solid;
             border-color:  #3A4758 transparent transparent transparent;
             position: absolute;
             top: -12px;
             left: 50%;
             transform: translateX(-50%);
          }
          p{
            display: block;
          }
        }
        p{
          width: 87px;
          height: 86px;
          padding: 5px;
          background: #3A4758;
          position: absolute;
          bottom: 57px;
          display: none;
          left: -28px;
        }
      }
      li:nth-child(1){
        width: 46px;
        height: 45px;
        background-image: url(../assets/img/wb.png);
      }
      li:nth-child(2){
        width: 44px;
        height: 45px;
        background-image: url(../assets/img/wx.png);
      }
      li:nth-child(3){
        background-image: url(../assets/img/dy.png);
      }
      li:nth-child(4){
        background-image: url(../assets/img/qq.png);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/foot.vue